import script from "./RegistrationOfficeComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationOfficeComponent.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationOfficeComponent.vue?vue&type=style&index=0&id=8adca44e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8adca44e"]])

export default __exports__